module.exports = __webpack_public_path__ + "static/media/format-video-outline--dark.eab3c272.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/format-video-outline--dark.svg
// module id = 806
// module chunks = 0